import { Link } from 'react-router-dom';
import { SeoHead, organizationLd, webSiteLd, webPageLd } from '../seo';

export default function ListYourParking() {
  return (
    <>
      <SeoHead
        title="List Your Parking Spot — Earn From Empty Space | Parksy"
        description="Got a spare driveway, garage, or apartment slot? List it on Parksy.rent for free and get matched with verified seekers near you. Zero brokerage."
        canonical="https://parksy.rent/list-your-parking"
        ogImage="https://parksy.rent/og/list-your-parking.png"
        schemas={[organizationLd(), webSiteLd(), webPageLd({ name: 'List Your Parking', description: 'List your parking spot for free on Parksy.rent.', url: 'https://parksy.rent/list-your-parking' })]}
      />
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">List your parking. Get matched with seekers nearby.</h1>
        <p className="text-lg text-gray-600 mb-8">
          A spare driveway, an empty apartment slot, a commercial lot with vacancies — turn idle
          space into monthly income. No signup. No brokerage. We email you only when there's a
          real match.
        </p>

        <ol className="space-y-4 mb-8">
          {[
            ['Drop a pin', 'Click the map and place a pin at your parking location.'],
            ['Add details', 'Vehicle types, hourly/daily/monthly rates, covered, security, EV charging.'],
            ['Get matched', 'Our engine runs daily. When a compatible seeker lands within 3 km, both sides get an email.'],
          ].map(([t, d], i) => (
            <li key={i} className="flex gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-parksy-600 text-white flex items-center justify-center font-bold">{i + 1}</div>
              <div>
                <h3 className="font-semibold text-gray-900">{t}</h3>
                <p className="text-gray-600 text-sm">{d}</p>
              </div>
            </li>
          ))}
        </ol>

        <Link
          to="/"
          className="inline-block bg-parksy-600 hover:bg-parksy-700 text-white font-medium px-6 py-3 rounded-lg"
        >
          Open the map and drop a pin →
        </Link>

        <div className="mt-12 grid sm:grid-cols-3 gap-4 text-sm">
          {[
            ['Free forever', 'No listing fees, no commission, no subscription.'],
            ['Anonymous', 'Email & phone stay private until a match.'],
            ['Anti-spam', 'IP rate limits, community reports, statistical filtering.'],
          ].map(([t, d]) => (
            <div key={t} className="bg-white border rounded-xl p-4">
              <h3 className="font-semibold text-gray-900 mb-1">{t}</h3>
              <p className="text-gray-600">{d}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
